import { parseFilters } from '../../../libs/filter.lib'
import { QueryStringFilter } from '../../../models/query-string.model'
import { UsersListingPage } from '../models/user-listing.model'
import { UserField, UserSearchParams } from '../models/user-search.model'

export function parseUserFilters(
  params: UserSearchParams,
  filters: UserSearchParams,
): UserSearchParams {
  return parseFilters(params, filters, userFilterParams)
}

/**
 * Parse user filter params
 * @param params - the search params
 * @param filter - the filter to parse
 * @returns the user search params updated
 */
export function userFilterParams(
  params: UserSearchParams,
  filter: QueryStringFilter<UserField>,
): UserSearchParams {
  const searchParams: UserSearchParams = {}

  switch (filter.field) {
    case '_id':
      if (filter.value !== null) {
        searchParams._id = filter.value
      }
      break
    case 'type':
      if (filter.operator === '=') {
        searchParams.type = filter.value
      }
      break
    case 'username':
      if (filter.operator === '=') {
        searchParams.username = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['username:ct'] = filter.value
      }
      break
    case 'name':
      if (filter.operator === '=') {
        searchParams.name = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['name:ct'] = filter.value
      }
      break
    case 'surname':
      if (filter.operator === '=') {
        searchParams.surname = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['surname:ct'] = filter.value
      }
      break
    case 'email':
      if (filter.operator === '=') {
        searchParams.email = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['email:ct'] = filter.value
      }
      break
    case 'tenants.settings.warehouseId':
      if (filter.value !== null) {
        searchParams['tenants.settings.warehouseId'] = filter.value
      } else {
        searchParams['tenants.settings.warehouseId:ex'] = false
      }
      break
    case 'tenants.settings.pickupPointId':
      if (filter.value !== null) {
        searchParams['tenants.settings.pickupPointId'] = filter.value
      } else {
        searchParams['tenants.settings.pickupPointId:ex'] = false
      }
      break
    case 'roles._id':
      if (filter.value !== null) {
        searchParams['roles._id'] = filter.value
      } else {
        searchParams['roles._id:ex'] = false
      }
      break
    case 'isDisabled':
      searchParams.isDisabled = filter.value
      break
    case 'isGuest':
      searchParams.isGuest = filter.value
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

/**
 * Parse users page with relative fields
 * @param usersPage - the users listing page
 * @param tenantId - the tenant ID
 * @returns the users page parsed
 */
export function parseUsersPage(
  usersPage: UsersListingPage,
  tenantId?: string,
): UsersListingPage {
  if (!tenantId) {
    return usersPage
  }

  return {
    ...usersPage,
    data: usersPage.data?.map((u) => ({
      ...u,
      isGuest: u.tenantId !== tenantId,
      isDisabled: !!u.isDisabled,
    })),
  }
}
